<template>
  <v-app>
    <notifications />
    <router-view :key="$route.path" />
  </v-app>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
      const chatScriptUrl = '//v2.zopim.com/?3UoWaJX2EbRu4Gr86q0V7Huf75SLUcrz';
      const chatScript = document.createElement('script');
      chatScript.setAttribute('src', chatScriptUrl);
      document.body.appendChild(chatScript);
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");
.v-application {
  font-family: "Montserrat" !important;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.vue-notification-group {
    top: 35px !important;
    width: 86% !important;
    left: 0;
}

.vue-notification-wrapper {
    border-radius: 20px;
    overflow: hidden;
}

.vue-notification-template.vue-notification.error{
    background-color: #F9DBDB !important;
    border-color: #F9DBDB !important;
    border-radius: 20px;
}

.vue-notification-template.vue-notification.success{
    background-color: #FCECB3 !important;
    border-color: #FCECB3 !important;
    border-radius: 20px;
}

.vue-notification.error {
    background: #F9DBDB !important;
    border-color: #F9DBDB !important;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    padding: 35px 45px;
}

.vue-notification.success {
    background: #FCECB3 !important;
    border-color: #FCECB3 !important;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    padding: 35px 45px;
}

.notification-title {
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #1E4F2C;
    margin-bottom: 13px;
}

.notification-content {
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #1E4F2C;
}

@media (max-width: 1440px) {
     .vue-notification-group {
          width: 77% !important;
     }
 }

 @media (max-width: 767px) {
     .vue-notification-group {
        top: 100px !important;
        width: 100% !important;
    }
 }

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
